"use strict";

exports.__esModule = true;
exports.TimelineQueryController = TimelineQueryController;
var _react = _interopRequireDefault(require("react"));
var _libTimeline = require("@vimana/lib-timeline");
var _DataAccessorContext = require("../../API/DataInterface/DataAccessorContext");
var _APIQueryController = require("../../API/APIQueryController");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Queries a given timeline and makes the results available to consumers
 * via a render prop.
 */
function TimelineQueryController(_ref) {
  var timelineName = _ref.timelineName,
    interval = _ref.interval,
    query = _ref.query,
    children = _ref.children;
  var startDate = new Date(interval.startMillis);
  var endDate = new Date(interval.endMillis);
  var dataAccessor = _react["default"].useContext(_DataAccessorContext.DataAccessorContext);
  var reqQuery = Object.assign({
    start: startDate.toISOString(),
    end: endDate.toISOString(),
    timeline: timelineName
  }, query);
  return /*#__PURE__*/_react["default"].createElement(_APIQueryController.APIQueryController, {
    key: "" + interval.startMillis + interval.endMillis,
    query: reqQuery,
    load: function load() {
      return dataAccessor.getTimeline(Object.assign({
        start: startDate.toISOString(),
        end: endDate.toISOString(),
        timeline: timelineName
      }, query));
    },
    normalizeResponse: normalizeTimeline
  }, children);
}
function normalizeTimeline(input) {
  return input.sort(_libTimeline.compareTimelineItemsByInterval);
}